module.exports = __webpack_public_path__ + "img/users-white.14e5f957.svg";